import { settings } from '../../main/configs/settings'

export const getFileURL = (file: File): string => window.URL.createObjectURL(file)

export const getFileByFilename = (filename: string): string => (
  `${settings.ASSETS_URL}/${filename}`
)

export const urlToFile = async (
  url: string,
  name: string,
  defaultType = 'image/jpeg',
): Promise<File> => {
  const response = await fetch(url)
  const data = await response.blob()
  return new File([data], name, {
    type: data.type || defaultType,
  })
}
